import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Button from '../../components/Button/Button';
import Header from '../../components/Header/Header';

import translate from '../../libs/i18n';

import notFoundIllustration from '../../assets/images/healthscan-not-found-illustration.svg';

import { NotFoundStyle } from './NotFoundStyle';

const NotFound = ({ children, title, to, toText }) => {
  const language = useSelector((state) => state.settings.language);

  const titleLanguage = useMemo(() => {
    if (title && title.length) {
      return translate(title, language);
    }

    return translate('pageNotFound', language);
  }, [language, title]);

  return (
    <NotFoundStyle>
      <Header />
      <div className="not-found-container">
        <div className="not-found-text-content">
          {titleLanguage && titleLanguage.length ? (
            <h1 className="not-found-title">{titleLanguage}</h1>
          ) : null}
          <div className="not-found-instruction">
            {children || (
              <p>
                {`${translate(
                  'typedAddressIncorrectly',
                  language
                )}. ${translate('tryGoingBackOrVisit', language)}`}{' '}
                <Link to="/">{`${translate('our', language)} site`}.</Link>
              </p>
            )}
          </div>
          {to && to.lenght && toText && toText.lenght ? (
            <div className="go-to-button-wrapper">
              <Button
                type="link"
                theme="default"
                size="default"
                text={translate('goToExamsPanel', language)}
                to="/"
              />
            </div>
          ) : null}
        </div>
        <div className="not-found-image-content">
          <div className="logo-wrapper">
            <img
              className="not-found-illustration"
              src={notFoundIllustration}
              alt="Login illustration"
            />
          </div>
        </div>
      </div>
    </NotFoundStyle>
  );
};

NotFound.propTypes = {
  title: PropTypes.string,
  to: PropTypes.string,
  toText: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.node]),
};

NotFound.defaultProps = {
  title: 'pageNotFound',
  to: '',
  toText: '',
  children: null,
};

export default NotFound;
